import { paramsSelector, useStore } from '@liveHelper/models/store'

import { defaultApiHost } from '@src/helpers'

/**
 * @returns The API host provided from the params, or the default Api host if
 * not provided.
 */
export const useApiHost = () => {
  const { api_host } = useStore(paramsSelector)
  return api_host ?? defaultApiHost
}
